import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

export const GridCard = styled(Grid)({
    padding: '16px 24px',
    background: '#FFFFFF',
    border: '1px solid #DDDDDD',
    borderRadius: '8px'
})